(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ua-parser-js"), require("lodash"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["ua-parser-js", "lodash", "axios"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("ua-parser-js"), require("lodash"), require("axios")) : factory(root["uaParser"], root["_"], root["axios"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(Function('return this')(), function(__WEBPACK_EXTERNAL_MODULE__8rrE__, __WEBPACK_EXTERNAL_MODULE_YLtl__, __WEBPACK_EXTERNAL_MODULE_zr5I__) {
return 